import { MonitorMobbileLinearIcon } from '../../../../../../icons-lib';
import React from 'react';
import { Typography } from '@mui/material';
import config from '../../../../../../config';

export const CampaignFormFields = [
    // tipText - add tip icon and text on hover
    // secondaryLabel - add subtext under the label
    // helpText - add help text under the input
    // needDivider - add a divider after the field
    {
        title: 'campaignDetails',
        icon: <MonitorMobbileLinearIcon style={{ color: '#fff' }} />,
        fields: [
            {
                id: 'campaignName',
                label: 'campaignName',
                type: 'text',
                tipText: 'campaignNameTipText'
            },
            {
                id: 'languages',
                label: 'languages',
                type: 'checkboxes',
                options: config.languages,
                secondaryLabel: 'languagesSecondaryLabel',
                needDivider: true
            }
        ]
    },
    {
        title: 'notificationDetails',
        icon: <Typography variant="h6">01</Typography>,
        fields: [
            {
                id: 'notificationDetails',
                label: 'notificationDetails',
                type: 'notificationDetails',
                anotherFieldData: 'languages',
                needDivider: true
            },
            {
                id: 'location',
                label: 'associatedPartnerShop',
                tipText: 'associatedPartnerShopTipText',
                type: 'serverSelect',
                associatedSettings: {
                    primary: 'name',
                    secondary: 'email',
                    primaryType: 'lang',
                    primaryLabel: 'partner'
                },
                searchType: 'server', // server, client
                searchFields: ['name', 'email'], // for server search
                serverController: 'merchantLocations'
            },
            {
                id: 'imageUrl',
                label: 'customImage',
                type: 'imageUpload',
                helpText: 'customImageHelpText',
                needDivider: true
            },
            {
                id: 'displayEndDate',
                label: 'displayEndDate',
                type: 'switch',
                options: ['no', 'yes']
            },
            {
                id: 'campaignEndDate',
                label: 'campaignEndDate',
                type: 'dateTime',
                helpText: 'campaignEndDateHelpText'
            }
        ]
    },
    {
        title: 'audience',
        icon: <Typography variant="h6">02</Typography>,
        fields: [
            {
                id: 'audiences',
                label: 'audienceLists',
                tipText: 'audienceListsTipText',
                type: 'serverSelect',
                serverController: 'marketingAudiences',
                associatedSettings: {
                    primary: 'name',
                    secondary: 'usersCount',
                    multiple: true,
                    primaryType: 'text',
                    secondaryType: 'number',
                    hideSecondaryLabel: true
                },
                saveFullData: true,
                searchType: 'server',
                searchFields: ['name', 'usersCount'],
                needDivider: true
            },
            {
                id: 'totalRecipients',
                label: 'totalRecipients',
                type: 'totalItems',
                anotherFieldData: 'audiences',
                keyAnotherField: 'usersCount',
                pillLabel: 'totalUsers'
            }
        ]
    },
    {
        title: 'deepLink',
        icon: <Typography variant="h6">03</Typography>,
        fields: [
            {
                id: 'deepLink',
                label: 'deepLink',
                type: 'deepLinks',
                tipText: 'deepLinkTipText',
                helpText: 'deepLinkHelpText'
            }
        ]
    },
    {
        title: 'notificationTiming',
        icon: <Typography variant="h6">04</Typography>,
        endOfForm: true,
        fields: [
            {
                id: 'notificationTiming',
                label: 'notificationTiming',
                type: 'notificationTiming',
                needDivider: true
            },
            {
                id: 'scheduledDate',
                label: 'scheduledDate',
                type: 'dateTime',
                helpText: 'scheduledDateHelpText'
            }
        ]
    }
];
